import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getMembers, updateMemberStatus } from '../services/members.service';

export const useMembers = (params = {}) => {
  return useQuery({
    queryKey: ['members', params],
    queryFn: () => getMembers(params),
    staleTime: 1000 * 60 * 2,
  });
};

export const useUpdateMemberStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, status }) => updateMemberStatus(id, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['members'] });
    },
  });
};
